var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownloadGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Arrow Download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M12.1665 13.6665C12.4427 13.6664 12.6667 13.8902 12.6667 14.1663C12.6667 14.4425 12.443 14.6664 12.1668 14.6665L3.50014 14.669C3.224 14.6691 3 14.4453 3 14.1691C3 13.893 3.22371 13.6691 3.49986 13.669L12.1665 13.6665ZM7.76549 1.34099L7.83333 1.33643C8.08646 1.33643 8.29566 1.52453 8.32877 1.76858L8.33333 1.83643L8.33267 10.9598L10.8139 8.47954C10.9914 8.30205 11.2692 8.28594 11.4649 8.43119L11.521 8.47961C11.6985 8.65714 11.7146 8.93492 11.5693 9.13064L11.5209 9.18672L8.18915 12.5178C8.01172 12.6952 7.73413 12.7114 7.5384 12.5663L7.48232 12.518L4.14669 9.18692C3.95129 8.9918 3.95108 8.67521 4.14621 8.47982C4.3236 8.30219 4.60136 8.28586 4.7972 8.43096L4.85331 8.47933L7.33267 10.9551L7.33333 1.83643C7.33333 1.5833 7.52144 1.3741 7.76549 1.34099L7.83333 1.33643L7.76549 1.34099Z",
    fill: "#CFD6D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadGray);
export default __webpack_public_path__ + "static/media/icon-download-gray.4a24ed76684dda779a8e0ace7a84c9bd.svg";
export { ForwardRef as ReactComponent };